import {selector} from "./selector";
import { translate } from "../../../app/localisation";

let isClick = false;

const invoicePreviewModal = function (e) {
    e.preventDefault();
    const bill = $(e.target).closest('tr').data('entity');
    const currency = $(e.target).data('currency');
    const $modal = $(selector.invoiceModal).modal('show');
    var localizedMessage = messages.customer_pay_bills_success; 
    
    API.service.customer.getBillInvoiceData(bill.id, currency).done(function (response) {
        $modal.find('.modal-body').html(response);
    });
}

const addCreditAmount = function () {
    let amount = parseInt($(selector.chargeAmount).val());
    let $preloader = $(selector.preloader);

    $preloader.html($(selector.preloaderText).val());

    API.service.customer.addCredit(amount)
        .done(function (response) {
            $preloader.html(response['message']);
        })
        .fail(function (response) {
            $preloader.html(response['message']);
        });
}
const payBill = (e) => {
    e.preventDefault();
    const $row = $(e.target).closest('tr');
    const billId = $row.data('entity');
    const payUrls = {modal: $row.data('payUrl'), initiate: $row.data('payItemUrl')};
    const $modal = $(selector.modalPayBill).modal("show");
    API.service.customer.customerPayBill(billId, payUrls.modal).done(function (response) {
        $modal.find('.modal-body').html(response);
        $modal.find(selector.btnMakePayment).off('click').on('click', {
            billId: billId,
            payUrls: payUrls,
            modal: $modal,
        }, _makePayment);
    });
}

const _errorsHtml = function (response) {
    const json = response && response.responseJSON ? response.responseJSON : null;
    if (!json) {
        return translate('error_general');
    }
    let errorsHtml = '';
    if (json.errors) {
        for (let prop in json.errors) {
            if (json.errors.hasOwnProperty(prop) && json.errors[prop]) {
                errorsHtml += '<div>' + json.errors[prop] + '</div>';
            }
        }
    }
    if (errorsHtml === '' && json.message) {
        errorsHtml = json.message;
    }
    return errorsHtml !== '' ? errorsHtml : translate('error_general');
}

const _makePayment = function (e) {
    e.preventDefault();
    let billId = e.data.billId;
    let payUrls = e.data.payUrls || {};
    let $modal = e.data.modal;
    let $alert = $(selector.paymentAddAlert);

    if (isClick) {
        return;
    }
    isClick = true;

    $modal.find(selector.btnMakePayment).remove();
    $alert.attr('class', 'alert alert-warning').html(translate('payment_in_progress')).show();

    API.service.customer.customerPayBill(billId, payUrls.modal).done(function (response) {
        API.service.customer.getCustomerPayBill(billId, payUrls.initiate).done(function (res) {
            if(res.message){
                $alert.attr('class', 'alert alert-success').html(res.message).show();
            }
            if(res.error){
                $alert.attr('class', 'alert alert-danger').html(res.error).show();
            }
            isClick = false;
            setTimeout(function (){
                window.location.reload();
          }, 5000);
        }).fail(function (res) {
            isClick = false;
            $alert.attr('class', 'alert alert-danger').html(_errorsHtml(res)).show();
        });
    }).fail(function (response) {
        isClick = false;
        $alert.attr('class', 'alert alert-danger').html(_errorsHtml(response)).show();
    });
}

export {invoicePreviewModal, addCreditAmount, payBill, _makePayment};